import script from "./DefaultLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefaultLayout.vue?vue&type=script&setup=true&lang=ts"

import "./DefaultLayout.vue?vue&type=style&index=0&id=9ae86770&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ae86770"]])

export default __exports__